import React from "react";
import PropTypes from "prop-types";
import { deleteAdmin } from "../../../action/admin/getActiveLoginUserList";
import { frontEndLogs } from "../../../action/logs/frontEndLogs";
import { analyticsClickEvent } from "../../../action/firebaseAnalytics/firebaseAnalytics";

export default class DeleteAdminModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isDeleting: false
		}
	}

	handleDeleteAdmin = async () => {
		analyticsClickEvent('admin_delete_confirm_clicked', '');
		frontEndLogs('admin_delete_confirm_clicked', false, 200, 'admin_dashboard');
		const deletedAdminId = this.props.selectedAdmin.id;
		const payload = {
			adminId: this.props.selectedAdmin.id
		};
		this.props.closeDeleteAdminModal();
		this.props.setLoading(true);

		try {
			const response = await deleteAdmin(payload);

			if (response?.statusCode === 200) {
				analyticsClickEvent('admin_deleted_successfully', '');
				frontEndLogs('admin_deleted_successfully', false, 200, 'admin_dashboard');
				const loggedInAdminId = sessionStorage.getItem("admin_user_id");
				if (String(loggedInAdminId) === String(deletedAdminId)) {
					analyticsClickEvent('admin_self_logout_after_delete', '');
					frontEndLogs('admin_self_logout_after_delete', false, 200, 'admin_dashboard');
					localStorage.clear();
					sessionStorage.clear();
					window.location.href = "/login";
					return;
				}
				this.props.openResponseModal(response.message, true, "Admin Deleted Successfully");
			} else {
				frontEndLogs('admin_delete_failed', true, response?.statusCode || 400, 'admin_dashboard');
				this.props.openResponseModal(response?.message || "Unable to delete admin", false, "Admin Deletion Failed");
			}
		} finally {
			this.props.setLoading(false);
		}
	};

	render() {
		const { showDeleteAdminModal, selectedAdmin } = this.props;
		if (!showDeleteAdminModal) {
			return null;
		}
		return (
			<div className="modal-overlay">
				<div className="delete-admin-modal">
					<h4> Delete Admin</h4>
					<p> Are you sure want to delete the <b>{" "}{selectedAdmin?.name}</b>?</p>
					<div className="admin-modal-footer">
						<button
							type="button"
							className="delete-cancel-btn"
							onClick={this.props.closeDeleteAdminModal}
						>
							Cancel
						</button>
						<button
							type="button"
							className="delete-confirm-btn"
							onClick={this.handleDeleteAdmin}
						>
							Delete
						</button>
					</div>
				</div>
			</div>
		)
	}
}

DeleteAdminModal.propTypes = {
	showDeleteAdminModal: PropTypes.bool.isRequired,
	closeDeleteAdminModal: PropTypes.func.isRequired,
	openResponseModal: PropTypes.func.isRequired,
	setLoading: PropTypes.func.isRequired,
	selectedAdmin: PropTypes.object
};
